export default __webpack_public_path__ + "static/media/pantalon-deportivo-hombre.3363ddf7.png";